

















































import { Component } from 'vue-property-decorator';
import i18n from '@/services/i18n';
import { ComponentBase } from '../components';
import * as common from '../common';
import { dictDefinitionMap } from './common';
import type { DictDefinition, DictDefinitionKey } from './common';


const translates = {
    get backToDictList(): string {
        return i18n.choose(
            'Назад к списку справочников',
            'Анықтамалық әдебиеттер тізіміне қайта келу',
            'Back to the list of reference books',
        );
    },
    errors: {
        unknownDictionary(key: string): string {
            return i18n.choose(
                (str: string): string => `Нет страницы для справочника с ключом "${str}"`,
                (str: string): string => `"${str}" кілті бар анықтамалық бет жоқ`,
                (str: string): string => `No page for dictionary with key "${str}"`,
            )(key);
        },
    },
    get noRights(): string {
        return i18n.choose(
            'У текущего пользователя нет уровня доступа "Админ" для модуля "Штатное расписание"',
            'Ағымдағы пайдаланушыда «Қызметкерлер» модулі үшін «Әкімші» қатынасу деңгейі жоқ',
            'The current user does not have the "Admin" access level for the "Staffing" module',
        );
    },
};


@Component
export default class DictPage extends ComponentBase {
    constructor() {
        super('');
    }


    // region Параметры страницы
    private get pageParamKey(): string {
        return this.$route.params.key;
    }
    // endregion


    // region Util
    // noinspection JSUnusedLocalSymbols
    private translates = translates;

    private get isAdmin(): boolean {
        return common.staffTabAccess.isAdmin;
    }
    // endregion


    // region Отображаемый справочник
    private get dict(): DictDefinition | null {
        return dictDefinitionMap[this.pageParamKey as DictDefinitionKey] ?? null;
    }
    // endregion
}
